import { __decorate } from "tslib";
import { Component, Input, ViewEncapsulation, } from '@angular/core';
import { WebsiteThemeService } from '../../services/website-theme.service';
import { DomSanitizer } from '@angular/platform-browser';
import { WebClientService } from '../../services/webclient-settings.service';
/**
 * Order Form Component
 */
let SummaryDetailsComponent = class SummaryDetailsComponent {
    constructor(themeService, sanitizer, webSettingsService) {
        this.themeService = themeService;
        this.sanitizer = sanitizer;
        this.webSettingsService = webSettingsService;
        this.mainColor = '';
        this.backColor = '';
        this.borderRadiusSmaller = '';
        this.borderRadiusLarger = '';
        this.themeService.getTheme().subscribe((data) => {
            this.mainColor = this.themeService.getStyleAttribute('main_color');
            this.backColor = this.themeService.getStyleAttribute('side_menu');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
        });
    }
    ngOnInit() {
    }
};
SummaryDetailsComponent.ctorParameters = () => [
    { type: WebsiteThemeService },
    { type: DomSanitizer },
    { type: WebClientService }
];
__decorate([
    Input()
], SummaryDetailsComponent.prototype, "txType", void 0);
__decorate([
    Input()
], SummaryDetailsComponent.prototype, "currency", void 0);
__decorate([
    Input()
], SummaryDetailsComponent.prototype, "summaryData", void 0);
SummaryDetailsComponent = __decorate([
    Component({
        selector: 'ecd-summary',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./summary-details.component.html")).default
    })
], SummaryDetailsComponent);
export { SummaryDetailsComponent };
